<template>
    <div class="profile bg-white">
        <div class="mt-5 border shadow p-4">
            <div class="row">
                <div class="col-4 col-sm-3 col-lg-2 float-left">
                    <div class="text-left">
                        <img src="../assets/KOVATEK/IMAGES/mike.png" alt="" class="rounded-circle img-height" />
                    </div>
                <div class="mt-2"><span class="text-size1 font-weight-bold ml-3">$30</span>/hr</div>

                </div>
                    
                <div class="col-8 col-sm-9 col-lg-10">
                    <div class="row">
                            <div class="col">
                                <p class="adjust-p-size text-left ml-2 mb-0">
                                    Mike .P <img class="ml-2 mb-1" style="height:16px;" src="../assets/KOVATEK/svg-embed/correct.svg" alt="" /> <!-- <font-awesome-icon icon="user-check" class="user-check-col ml-2"></font-awesome-icon> -->
                                </p>
                                <div class="text-left font-weight-bold ml-2 mt-2 mb-2"><font-awesome-icon icon="map-marker-alt" class="text-dark mr-2"></font-awesome-icon>Lagos, Nigeria</div>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <!-- <h5 class="text-left font-weight-bold ml-2">95%</h5>
                                <div class="progress cont-progress-height ml-2">
                                <div class="progress-bar" style="width:95%;background-color:#41CBF6;"></div>
                                </div>
                                <p class="text-left mt-2 ml-2">Task Completed</p> -->
                                <!-- <p class="font-weight-bold text-size2 font-italic mt-1 mb-0">Web Developer</p> -->
                                <p class="text-uppercase text-size2 mt-3 font-weight-bold text-senior mb-1">senior</p>

                                <h6 class="text-size2 font-weight-bold mt-0 pb-0">
                                    <img src="../assets/KOVATEK/svg-embed/best.svg" alt="" />
                                    <span class="text-size1 ml-2">9.5</span> <span class="text-size4 ml-2"> 178 reviews</span> 
                                </h6>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="">
                <div class="">
                    <h5 class="mt-4 text-left">Profiles</h5>
                    <!-- <a-tabs type="card">
                        <a-tab-pane tab="General Profile" key="1">Content of Tab Pane 1</a-tab-pane>
                        <a-tab-pane tab="Front-End Development" key="2">Content of Tab Pane 2</a-tab-pane>
                        <a-tab-pane tab="Back-End Development" key="3">Content of Tab Pane 3</a-tab-pane>
                    </a-tabs> -->
                    <a-tabs defaultActiveKey="1">
                        <a-tab-pane tab="General Profile" key="1">
                            <div class="text-left">
                                <h5>Experienced PHP/NodeJs/Go Developer</h5>
                                <p>I am backend developer with more than 7 years experience on web development. My excellent knowledge includes:</p>
                                <div :key="skills" v-for="skills in generalSkills" class="mb-4 font-weight-bolder">
                                    <p>* {{skills.name}} {{skills.level}}</p>
                                    <p>- {{skills.frameworks}}</p>
                                </div>
                            </div>
                            
                        </a-tab-pane>
                        <a-tab-pane tab="Front-End" key="2" forceRender>
                            <div class="text-left">
                                <h5> VueJS/Jquery Developer </h5> 
                                <div class="">
                                <p> Experienced on: </p>

                                    <p :key="skills" v-for="skills in feExperience" class="font-weight-bolder">
                                        - {{skills}}
                                    </p>
                                </div>
                                <div class="my-4">
                                    <p> Skills: </p>
                                    <span :key="skills" v-for="skills in feSkills" class="font-weight-bolder">
                                        {{skills}},
                                    </span>
                                </div>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane tab="Back-End" key="3">
                            <div class="text-left">
                                <h5> Experienced Back-end Developer </h5> 
                                <div class="">
                                <p> Experienced on: </p>

                                    <p :key="skills" v-for="skills in beExperience" class="font-weight-bolder">
                                        - {{skills}}
                                    </p>
                                </div>
                                <div class="my-4">
                                    <p> Skills: </p>
                                    <span :key="skills" v-for="skills in beSkills" class="font-weight-bolder">
                                        {{skills}},
                                    </span>
                                </div>
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                    <div>
                        <h6 class="text-left font-weight-bold">I am problem solving, eager to learn new things if needed, Does Something works for you? Let's get in touch.</h6>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-4 border shadow">
            <div class="bg-light p-4 border border-top-0">
                <h5>Work History and Feedback </h5>
            </div>
            <div class="p-4">
                <div :key="work" v-for="work in workHistory">
                    <div class="row">
                    <div class="col-md-9 text-left">
                        <h5 class="font-weight-bolder">{{work.title}}</h5>
                        <span>
                            <span :key="n" v-for="n in work.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{work.star}}.00</b> 
                            <span class="font-weight-light">{{work.duration}}</span>
                        </span>
                        <p class="font-italic text-size2">{{work.comment}}</p>
                    </div>
                    <!-- <div class="col-md-3">

                    </div> -->
                    <div class="col-md-3 text-right float-text">
                    <h6 class="font-weight-bolder">${{work.earned}}</h6>
                    <h6>${{work.earnedPerHour}}.00 / hr </h6>
                    <h6>{{work.hours}} hours </h6>
                    </div>
                </div>
                <hr>
                </div>
                
            </div>
        </div>

        <div class="mt-4 border shadow">
            <div class="bg-light p-4 border border-top-0">
                <h5>Portofolio </h5>
            </div>
            <div class="p-4">
                <div class="row px-4">
                    <div class="col-sm-12 col-md-5 my-3 mx-auto bg-light border add-h"></div>
                    <div class="col-sm-12 col-md-5 my-3 mx-auto bg-light border add-h"></div>
                </div>
            </div>
        </div>

        <div class="mt-4 border shadow">
            <div class="bg-light p-4 border border-top-0">
                <h5>Skills </h5>
            </div>
            <div class="p-4">
                <div class="text-left d-flex flex-wrap">
                    <span class="bg-skills px-3 py-2 ml-3 mb-3 rounded"  v-for="skill in skills" :key="skill">
                        {{skill}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'profile',
    data(){
        return {
            generalSkills: [
                    {name: 'PHP', level: '(Expert)', frameworks:'Laravel, Lumen, Symphony'},
                    {name: 'Database', level: '(Advance)', frameworks:'Mysql, Postgress, Database Design'},
                    {name: 'Nodejs', level: '(Advance)', frameworks:'ExpressJS, Lambda AWS'},
                    {name: 'Javascript', level: '(Advance)', frameworks:'jQuery,VueJS, extJS'},
                    {name: 'Golang', level: '(Advance)', frameworks:'Http, Gin, Chi, Gorm'},
                    {name: 'CI/CD', level: '', frameworks:'docker,travis,gitlab,circleci'},
                    {name: 'Project Management', level: '', frameworks:'Jira,Github,Gitlab,Bitbucket'}
            ],
            feExperience:[
                'Vanilla JavaScript', 'ExtJS dev (Version 3-6)', 'Classic Jquery development', 'VueJS'
            ],
            feSkills: [
                'JSON', 'Jquery', 'VueJS', 'JavaScript', 'SQL','Git', 'HTML'
            ],
            beExperience: [
                'API development with Laravel', ' Third API integration', 'Express NodeJS API development',
                'Design Relational Tables Database', 'SQL with MySQL', 'Lambda aws (NodeJS)',
                'API database driven development with Golang Mux Router /Gin/ Chi Framework',
                'Basic ElasticSearch integration'
            ],
            beSkills: [
                'PHP', 'Database', 'Backend RESTful APIs', 'Nodejs', 'Golang'
            ],
            skills: [
                'Laravel Framework', 'Nodejs','Golang','jQuery', 'JavaScript','database', 'Modeling','Vue.js','Express.js', 'Ext JS', 'Docker'
            ],
            workHistory: [
                {title: 'PHP / extJS / MVC Application Update', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Solid experience with PHP and extJS. Good quality work.',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'ExtJS prototype development', duration: 'Jul 2016 - Aug 2016', star: 5, comment: 'Nice job, completed on-time and high quality.',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19}
            ]
        }
    }
}
</script>

<style scoped>
.text-size1{
    font-size: 20px;
}
.text-size2{
    font-size: 16px;
}
.cont-progress-height{
    height: 6px;
}
.user-check-col{
    color: #41CBF6;
}
.adjust-p-size{
    font-size: 24px;
}
.text-size1{
    font-size: 16px;
}
.text-size2{
    font-size: 12px;
}
.text-size4{
    font-size: 10px;
}
.text-senior{
    color: #BD6377;
}
.text-intermediate{
    color: #BDBD50;
}

.img-height{
    height: 100px;
    width: 100px;
}
.add-h{
    height: 250px;
}
.bg-skills{
    background-color: #dde;
}

@media screen and (min-width: 992px) and (max-width: 1325px){

}

@media screen and (min-width: 768px) and (max-width: 991px){

}

@media screen and (max-width: 767px){
    .float-text{
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6{
        float: left;
        /* margin-right: 40px; */
    }
}
/* 
@media screen and (max-width: 550px){
    
} */
</style>